//校准浏览器缩放，仅仅支持高版本的chrome
const screenZoom = {
  correct: function () {
    let zoom = 1 / window.devicePixelRatio;
    let htmlNode = document.querySelector("html")
    if (dsf.isDef(htmlNode.style.zoom)) {
      htmlNode.style.zoom = zoom;
    }
  },
  watch: function () {
    window.addEventListener('resize', (evt) => {
      screenZoom.correct()
    })
  },
  disableEvent() {
    //禁止ctrl+-
    document.addEventListener('keydown', function (event) {
      if ((event.ctrlKey === true || event.metaKey === true)
        && (event.which === 61 || event.which === 107
          || event.which === 173 || event.which === 109
          || event.which === 187 || event.which === 189)) {
        event.preventDefault();
      }
    }, false);
    let eventName = 'mousewheel';
    if (dsf.client.type == 'FF') {
      eventName = 'DOMMouseScroll'
    }
    //火狐禁止ctrl+滚轮
    document.addEventListener(eventName, function (event) {
      if (event.ctrlKey === true || event.metaKey) {
        event.preventDefault();
      }
    }, { passive: false });
  },
  init: function () {
    if (!dsf.global.$isMobile) {
      screenZoom.disableEvent();
      //放弃使用zoom缩放页面，原因是会导致鼠标事件获得的坐标出现较大的偏差
      // screenZoom.correct();
      // screenZoom.watch();
    }
  }
}

export default screenZoom;